<div class="p-relative" fxLayoutAlign="center center">
  <img
    class="back-icon"
    src="assets/images/sidebar/back.svg"
    alt="left-arrow"
    (click)="onBack()"
  />
  <ng-content></ng-content>
  <div *ngIf="deleteIcon" class="delete-icon circle-50" (click)="onDelete()">
    <img src="assets/images/sidebar/delete.svg" alt="delete" />
  </div>
</div>

<div class="shadow-wrapper">
  <div class="overlay"></div>
  <div class="shadow-inside"></div>
</div>
